/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/


import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const prepulseStore = {
  namespaced: true,
  getters,
  mutations,
  state,
  actions,
  strict: process.env.NODE_ENV !== 'production'
}

export default prepulseStore